import { useEffect, useState } from "react";
import "../../css/Blog.css";
import { getPresentations } from "../../services/portfolioService";
import LoadingState from "../common/LoadingState";

const Talks = ({ selectedCategory, selectedTags }) => {
  const [presentations, setPresentations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPresentations = async () => {
      try {
        const params = {};
        if (selectedCategory) params.category = selectedCategory;
        if (selectedTags?.length > 0) params.tags = selectedTags.join(",");

        const data = await getPresentations(params);
        setPresentations(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching presentations:", error);
        setLoading(false);
      }
    };

    fetchPresentations();
  }, [selectedCategory, selectedTags]);

  if (loading) {
    return <LoadingState />;
  }

  if (presentations.length === 0) {
    return <p className="talks-empty">No presentations found.</p>;
  }

  return (
    <div className="blog-list">
      {presentations.map((talk) => (
        <div key={talk.id} className="blog-list-item">
          {talk.preview_image && (
            <div className="blog-list-image-link">
              <img
                src={talk.preview_image}
                alt={talk.title}
                className="blog-list-thumbnail"
              />
            </div>
          )}
          <div className="blog-list-content">
            <h4 className="blog-list-title">{talk.title}</h4>
            <div className="blog-meta mb-2">
              {new Date(talk.date).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
              {talk.category_name && ` · ${talk.category_name}`}
            </div>
            {talk.tags && talk.tags.length > 0 && (
              <div className="blog-tags mb-2">
                {talk.tags.map((tag) => (
                  <span key={tag.id} className="me-1 blog-tag-badge">
                    {tag.name}
                  </span>
                ))}
              </div>
            )}
            {talk.description && (
              <p className="blog-summary mb-2">{talk.description}</p>
            )}
            {(talk.video_url || talk.slides_file) && (
              <div className="paper-links">
                {talk.video_url && (
                  <a
                    href={talk.video_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="paper-link-tag"
                  >
                    video
                  </a>
                )}
                {talk.slides_file && (
                  <a
                    href={talk.slides_file}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="paper-link-tag"
                  >
                    slides
                  </a>
                )}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Talks;
